import React from 'react';
import { Alert, Button, TextField, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';
import { useT } from '../../localization/LocalizationProvider';

export function UnlockPage({ header, assignedLabel, completionMessage, secretWord, setSecretWord, onUnlock, error }) {
  const t = useT();
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h4">{t('Player.RoundComplete.Congrats')}</Typography>
      <Typography>{completionMessage}</Typography>
      <Typography>{t('Player.Unlock.Prompt')}</Typography>
      <TextField fullWidth label={t('Player.Unlock.SecretWordLabel')} value={secretWord} onChange={(event) => setSecretWord(event.target.value)} />
      {error && <Alert severity="error">{error}</Alert>}
      <Button variant="contained" onClick={onUnlock}>{t('Buttons.UnlockNextRound')}</Button>
    </PlayerCardLayout>
  );
}
